import { BASE_PRESCRIPTION_NOTES_LANG_KEY } from '../components/NewPatient/PrescriptionNotes/RestorativeOptions/RestorativeOptions';
import { useLang } from '../util/lang';

const useDisplayRestorativeOptionValue = () => {
    const getNotes = useLang(`NewPatient`);
    const getValueDisplay = (value = '') => {
        if (!value || !value?.length) return getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.none`);
        return value;
    };
    return {
        getValueDisplay,
    };
};

export default useDisplayRestorativeOptionValue;
